import React from 'react';
import { School } from 'models/school';
import { getAuthenticatedAppLink } from 'helpers/tournament';
import './FollowerRegistration.scss';

export function canRegisterFollower(school: School) {
   return school.kind === 'SchoolUnion' && school.availableForRegistration === true &&
      school.allowedPermissionPresets?.TOURNAMENT_FOLLOWER === true;
}

export default function FollowerRegistration({ school }: { school: School }) {
   if (!canRegisterFollower(school)) return null;
   return <a className='follower-registration' href={getAuthenticatedAppLink('/follow?union=' + encodeURIComponent(school.id))}
      target='_blank' rel='noopener noreferrer' title={`Register to follow public tournaments ${school.name} organises or takes part in. No child link needed.`}>
      <span>Follow {school.name} in the app</span>
   </a>;
}
